import React, { useState } from "react";
import './SignUp.css'
// Assets
import Swal from 'sweetalert2'
import userIcon from '../Assets/person.png'
import emailIcon from '../Assets/email.png'
import passwordIcon from '../Assets/password.png'
import doctorIcon from '../Assets/doctor.png'
import genderIcon from '../Assets/gender.png'
import professionIcon from '../Assets/profession.png'
import confirmCodeIcon from '../Assets/confirmCode.png'
import countryIcon from '../Assets/countries.png'
import hospitalIcon from '../Assets/hospital.png'
import { COUNTRY_OPTIONS } from '../countriesData.js'
import surgeonslab_logo from '../Assets/surgeonslab_logo.png'
import { signUp, confirmSignUp } from "aws-amplify/auth";
import moment from 'moment'
import ResetPassword from '../ResetPassword/ResetPassword';
import * as signupApi from '../../api/signupApi';
import { useNavigate } from 'react-router-dom';
// import { useParams } from 'react-router-dom';

// The page is built for one role (REACT_APP_SIGNUP_ROLE, validated at build
// time in config-overrides.js). The signup flow (hospital check, Cognito,
// confirmation, user record, user limit, alerts) is common; these are the
// genuine Trainee / Mentor differences.
const ROLE_CONFIG = {
    trainee: {
        headerText: "Trainee SignUp",
        requireMentorname: false,
        // UserName in the user record is the entered Name.
        recordUserName: true,
        codeSentText: "Please check your email for confirmation code! ",
        // Role-specific fields of the create-user-record request.
        recordFields: ({ Mentorname, policyCheck }) => ({ Mentorname, UserAgreement: policyCheck }),
        limitNotFoundMessage: 'Item not found or Student attribute is missing',
        logInactiveEmail: false,
        // Sign Up / Submit are locked (gray, not clickable) while a request runs.
        lockButtons: true,
        // The user record write is awaited; a failure shows the confirmation error.
        awaitUserRecord: true,
        successAlertOptions: { allowOutsideClick: false },
    },
    mentor: {
        headerText: "Mentor SignUp",
        requireMentorname: true,
        // UserName in the user record stays '' (Name is never stored).
        recordUserName: false,
        codeSentText: "Please check your email for confirmation code!   ",
        // The Mentor record keeps the browser's createdAt (Date.toString()).
        recordFields: () => ({ createdAt: (new Date()).toString() }),
        limitNotFoundMessage: 'Item not found or Professors attribute is missing',
        logInactiveEmail: true,
        // Buttons are never locked and keep the inline submitStyle background.
        lockButtons: false,
        // The user record write is not awaited; a failure is only logged.
        awaitUserRecord: false,
        successAlertOptions: {},
    },
};

// ---- Mentor legacy code, kept commented out as on the `mentor` branch ----
// const API = generateClient();
// class App extends Component{
//   state = { username: '', password: '', email: '', Mentorname:'', authenticationCode: '', newPassword:'',confirmationCode:'', step: 0}
//   onChange = e => {
//     this.setState({ [e.target.name]: e.target.value})
//   }
//   signUp = async() => {
//     const {username, password, email, Mentorname} = this.state
//     try{
//         await signUp({username, password, options: {
//           userAttributes: {
//             email,
//             'custom:Mentorname' : Mentorname }}})
//         console.log('successfully signed up!!')
//         this.setState({step: 1})
//     } catch (err) {console.log('error signing up: ', err)}
//   }

const SignUp = () => {

    const role = process.env.REACT_APP_SIGNUP_ROLE || 'trainee';
    const roleConfig = ROLE_CONFIG[role];

    // const { page } = useParams();
    // console.log('Page:', page);
    const navigate = useNavigate();
    const navigateToResetPassword = () => {
        // Use the history object to navigate to Page 2
        navigate('/ResetPassword');
      };

    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [email, setEmail] = useState('');
    const [Mentorname, setMentorname] = useState('');
    const [confirmationCode, setConfirmationCode] = useState('');
    const [hospname, setHospname] = useState('');
    const [gender, setGender] = useState('');
    const [profession, setProfession] = useState('');
    const [country, setCountry] = useState('');
    // const [state, setState] = useState("Sign Up");
    const [username_OG, setUsername_OG] = useState('');
    const [policyCheck, setPolicyCheck] = useState('');

    const handleCheckboxChange = () => {
        setPolicyCheck(!policyCheck); // Toggle the state of isChecked
      };

    // const handleSelectChange = (event) => {
    //   setSelectedOption(event.target.value);
    // };

    // const [formData, setFormData] = useState({
    //     username: '',
    //     email: '',
    //     password: '',
    //     gender: '',
    //     country: '',
    //     profession: '',
    //     hospitalname: '',
    //     mentorname: '',
    //     ConfirmSignUp: false,
    //     ConfirmationCode: '',
    //     success: true,
    //     error: true,

    //     successSignUp: false,
    //     errorSignUp: false,
    //     MessageHeaderSignUp: "",
    //     MessageContentSignUp: "",

    //     successConfirmSignUp: false,
    //     errorConfirmSignUp: false,
    //     MessageHeaderConfirmSignUp: '',
    //     MessageContentConfirmSignUp: '',

    //     isResendButtonDisabled: false,
    //     resendText: "Resend code",
    //     count: 50,

    //     screenWidth: window.innerWidth,
    //     screenHeight: window.innerHeight,

    //     UserAuthID: "1b7e4ind-01022021-620bff1d",
    //     copied: false,
    //     registrationDone: false
    //   });

    //   const handleChange = (e) => {
    //     setFormData({
    //       ...formData,
    //       [e.target.name]: e.target.value,
    //     });
    //   };

    //   const signUp1 = (e) => {
    //     var username = document.getElementById("username")
    //     var password = document.getElementById("password")
    //     var email = document.getElementById("email")
    //     var hospitalValue = document.getElementById("hospname")
    //     var Mentorname = document.getElementById("mentorname")
    //     var gen = document.getElementsByName('genderinput')[0];
    //     var genderValue = gen.options[gen.selectedIndex].text;
    //     var prof = document.getElementsByName('profession')[0];
    //     var professionValue = prof.options[prof.selectedIndex].text;            
    //     var country = document.getElementsByName('country')[0];
    //     var countryValue = country.options[country.selectedIndex].text;
    //     try{
    //         signUp({username, password, options: {
    //         userAttributes: {
    //             email,
    //             'custom:Mentorname' : Mentorname }}})
    //         console.log('code sent !!')
    //     } catch (err) {console.log('error signing up: ', err)}

    //   };

    const [signupDisabled, setSignupDisabled] = useState(false);
    const [submitDisabled, setSubmitDisabled] = useState(false);

    const handleClick = () => {
        if (roleConfig.lockButtons) {
            setSignupDisabled(true); // Disable the submit button immediately
        }
        signUpFunc();
      };

    const signUpFunc = async (e) => {

        const username1 = document.getElementById("username").value;

        if (roleConfig.recordUserName) {
            setUsername_OG(username1);
        }
        var username = email;

        // Hospital verification now runs in the backend; the hospital list is
        // no longer sent to the browser.
        let hospitalVerified = false;
        try {
            ({ verified: hospitalVerified } = await signupApi.verifyHospital(role, hospname));
        } catch (error) {
            console.error('Error retrieving data from DynamoDB', error);
            throw new Error('Could not retrieve data from DynamoDB');
        }

        // Mentor's Name is required for Mentor only.
        if(email.length !== 0 && password.length !== 0 && (!roleConfig.requireMentorname || Mentorname.length !== 0) && gender.length !== 0 && hospname.length !== 0 && country.length !== 0 ) //profession.length != 0 &&
        {
            if (hospitalVerified)
            {
                if (policyCheck) {
                    try {
                        await signUp({
                            username,
                            password, options: {
                                userAttributes: {
                                    email,
                                    'custom:Mentorname': Mentorname,
                                    'custom:Profession': "Resident"
                                }
                            }
                        })
                        console.log('code sent !!')
                        console.log(username)
                        console.log(email)
                        console.log(gender)
                        Swal.fire({
                            title: "Submitted!",
                            text: roleConfig.codeSentText,
                            icon: "success"
                        }).then((result) => {
                            window.scrollTo(0, document.body.scrollHeight);
                        }); 
                        setAction("Confirm SignUp");
                    } catch (err) { 
                        console.log('error signing up: ', err)
                        Swal.fire({
                            title: "Error!",
                            text: "Error signing up your account",
                            footer: err.message,
                            icon: "error"
                        }); 
                        setSignupDisabled(false);
                    }
                } else{
                    Swal.fire({
                        title: "Error!",
                        text: "Kindly agree to the Terms of Use before Signing Up",
                        icon: "warning"
                }); 
                setSignupDisabled(false);
                }
            }
            else {
                Swal.fire({
                            title: "Error!",
                            text: "Error signing up your account",
                            footer: "Your institution is not verified. Kindly recheck and enter the valid name!",
                            icon: "error"
                        }); 
                setSignupDisabled(false);
            }
        }
        else{
            Swal.fire({
                title: "Error!",
                text: "Fill in all details",
                icon: "error"
            }); 
            setSignupDisabled(false);
            }
    }

    const checkUserLimit = async (e) => {

        // The ResidentsLimit / ProfessorsLimit check and the AccountStatus
        // update now run in the backend, with the same comparison logic as before.
        let status;
        try {
            ({ status } = await signupApi.checkUserLimit(role, hospname, email));
        } catch (error) {
            console.error('Error retrieving data from DynamoDB', error);
            throw new Error('Could not retrieve data from DynamoDB');
        }
        if (status === 'notFound') {
            // Return a message if the item is not found or the Student/Professors attribute is missing
            return roleConfig.limitNotFoundMessage;
        }
        if(status === 'inactive') {
            if (roleConfig.logInactiveEmail) {
                console.log("selected : ", email);
            }

            Swal.fire({
                title: "Info",
                text: "Your account is currently inactive since the maximum license limit is reached. Please contact administrator to activate your license.",
                icon: "info"
            }).then((result) => {
                if (result.isConfirmed) {
                  // User clicked "OK", execute function
                  window.scrollTo(0, 0);
                  window.location.reload();
                }
            });
        } 
        else {
            window.scrollTo(0, 0);
            window.location.reload();
        }
    }

    const handleSignUpConfirmation = async (e) => {
        if (roleConfig.lockButtons) {
            setSubmitDisabled(true);
        }
        var username = email
        if(confirmationCode.length !== 0) {
            try {
                await confirmSignUp({
                    username,
                    confirmationCode
                })

                var AccountCreatedOn = moment().format('MMMM Do YYYY, h:mm:ss a')
                // The UserInfoCathView record is written by the backend
                // (/<role>/create-user-record). Trainee awaits it, so a failure
                // shows the confirmation error below; Mentor only logs a failure.
                const userRecord = signupApi.createUserRecord(role, {
                    email,
                    UserName: username_OG,
                    gender,
                    hospname,
                    country,
                    AccountCreatedOn,
                    ...roleConfig.recordFields({ Mentorname, policyCheck })
                });
                if (roleConfig.awaitUserRecord) {
                    await userRecord;
                } else {
                    userRecord.catch((err) => {
                        console.error("Error adding record to DynamoDB:", err);
                    });
                }
                console.log("Signup Successful")
                Swal.fire({
                    title: "Success!",
                    text: "Successfully Signed Up to CathView",
                    icon: "success",
                    ...roleConfig.successAlertOptions
                }).then((result) => {
                    if (result.isConfirmed) {
                        checkUserLimit();
                    //   window.scrollTo(0, 0);
                    //   window.location.reload();
                    }
                });

            } 
            catch (err) {
                Swal.fire({
                    title: "Error!",
                    text: "Error confirming your account",
                    footer: err.message,
                    icon: "error"
                });
                setSubmitDisabled(false);
                console.log('error signing up: ', err)
            }
        }
    }

    const [action, setAction] = useState("CathView");
    const submitStyle = {
        background: '#033030',
      };
    const textStyle = {
        color: '#033030',
      };
      
    return (
        <div className="NavBar">
            <nav>
                <div className="logo">
                    <img className="logoPic" src={surgeonslab_logo} alt="SurgeonsLab Logo" />
                </div>
            </nav>

            <div className='container'>
                <div className="header">
                    <div className="text" style={textStyle}>{action}</div>
                    <div className="text-small">{roleConfig.headerText}</div>
                    <div className="underline" style={submitStyle}></div>
                </div>
                {/* <form onSubmit={handleSubmit}> */}
                <div className="inputs">
                        <div className="input">
                            <img src={userIcon} alt="User" />
                            <input type="text" placeholder="Name" id="username" value={username} onChange={(e) => setUsername(e.target.value)} />
                        </div> 
                    <div className="input">
                        <img src={emailIcon} alt="Email" />
                        <input type="email" placeholder="Email" id="email" value={email} onChange={(e) => setEmail(e.target.value)} />
                    </div>
                    <div className="input">
                        <img src={passwordIcon} alt="Password" />
                        <input type="password" placeholder="Password" id="password" value={password} onChange={(e) => setPassword(e.target.value)} />
                    </div>
                        <div className="input">
                            <img src={genderIcon} alt="Gender" />
                            <div className="select-dropdown">
                                <select name="genderinput" value={gender} onChange={(e) => setGender(e.target.value)}>
                                    <option value="">-- Select --</option>
                                    <option value="Male">Male</option>
                                    <option value="Female">Female</option>
                                    <option value="Others">Others</option>
                                </select>
                            </div>
                        </div>
                        {/* <div className="input">
                            <img src={professionIcon} alt="Profession" />
                            <div className="select-dropdown">
                                <select name="profession" value={profession} onChange={(e) => setProfession(e.target.value)}>
                                    <option value="">-- Profession --</option>
                                    <option value="Mentor">Mentor (Prof / Surgeon)</option>
                                    <option value="Resident">Resident</option>
                                    <option value="Technician">Technician</option>
                                </select>
                            </div>
                        </div> */}
                        <div className="input">
                            <img src={hospitalIcon} alt="Hospital" />
                            <input type="text" placeholder="Hospital or Institution Name" id="hospname" value={hospname} onChange={(e) => setHospname(e.target.value)} />
                        </div>
                        <div className="input">
                            <img src={userIcon} alt="User" />
                            <input type="text" placeholder="Mentor's Name" id="mentorname" value={Mentorname} onChange={(e) => setMentorname(e.target.value)} />
                        </div>
                        <div className="input">
                            <img src={countryIcon} alt="Country" />
                            <div className="select-dropdown">
                                <select name="country" value={country} onChange={(e) => setCountry(e.target.value)}>
                                    <option value="">-- Select Country --</option>
                                    {COUNTRY_OPTIONS.map((option) => (
                                        <option key={option.key} value={option.value}>
                                            {option.text}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div style={{paddingLeft:"70px"}}>
                            <div class="checkbox-wrapper-13">
                                <pre  style={{fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', sans-serif"}}>
                                    <input id="c1-13" type="checkbox" checked={policyCheck} onChange={handleCheckboxChange}  /><label for="c1-13">&nbsp;&nbsp;&nbsp;I agree to the <a href="https://www.surgeonslab.com/termsOfUse.php" target="_blank" rel="noopener">Terms of Use</a> and <a href = "https://www.surgeonslab.com/privacyPolicy.php" target="_blank" rel="noopener">Privacy Policy</a>.
                                </label></pre>
                            </div>    
                        </div>
                </div>

                <div className="submit-container">
                    <div
                        className={roleConfig.lockButtons ? `submit ${signupDisabled ? "gray" : ""}` : "submit"}
                        onClick={!signupDisabled ? handleClick : null}
                        style={roleConfig.lockButtons ? {
                            cursor: signupDisabled ? "not-allowed" : "pointer",
                            pointerEvents: signupDisabled ? "none" : "auto"
                        } : submitStyle}>
                            Sign Up
                    </div>
                    <div className={roleConfig.lockButtons ? `submit ${action === "CathView" || signupDisabled ? "gray" : ""}` : (action === "CathView" ? "submit gray" : "submit")}
                        onClick={navigateToResetPassword}
                        style={roleConfig.lockButtons ? {
                            cursor: signupDisabled ? "not-allowed" : "pointer",
                            pointerEvents: signupDisabled ? "none" : "auto"
                        } : undefined}>
                            Reset Password
                    </div>
                </div>

                <div className="inputs">
                    {/* {action==="Confirmation"?<div></div>:
                        <div className="input">
                            <img src={emailIcon} alt="Email" />
                            <input type="email" placeholder="Email" id="emailid"/>
                        </div>} */}

                    {action === "CathView" ? <div></div> :
                        <div className="inputs-otp">
                            <div style={{paddingLeft:"70px"}}>
                                <div class="checkbox-wrapper-13">
                                    <pre  style={{fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', sans-serif", fontWeight:"500"}}>
                                        <label>Enter the verification code
                                    </label></pre>
                                </div>    
                            </div>
                            <div className="input">
                                <img src={confirmCodeIcon} alt="Code" />
                                <input type="text" placeholder="Authentication Code" id="confirmationCode" value={confirmationCode} onChange={(e) => setConfirmationCode(e.target.value)} />
                            </div>

                            <div className="submit-container">
                                <div className={roleConfig.lockButtons ? `submit ${submitDisabled ? "gray" : ""}` : "submit"}
                                onClick={handleSignUpConfirmation}
                                style={roleConfig.lockButtons ? {
                                    cursor: submitDisabled ? "not-allowed" : "pointer",
                                    pointerEvents: submitDisabled ? "none" : "auto"
                                } : submitStyle}>
                                    Submit
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>
    );
};

export default SignUp;